import React from 'react';
import { connect } from 'react-redux';

import Box from '@bit/knotchinc.web-react-components.box';

import { Title } from 'components/Global/StatCard/styled.js';
import KeywordSearchLink from 'components/Global/Tag/KeywordSearchLink.jsx';
import TopSixList from 'components/Global/TopSixList/TopSixList.jsx';
import EntityItem from 'components/Global/EntityItem/EntityItem.jsx';
import {
  fetchPublishersTopBrands,
  fetchPublishersTopKeywords,
  fetchPublisherContentOverTime,
  SET_PUBLISHER_TOP_BRANDS_FILTER,
  SET_PUBLISHER_TOP_KEYWORDS_FILTER,
  SET_PUBLISHER_CONTENT_OVER_TIME_FILTER,
} from 'components/Pages/Entity/actions';
import ContentOverTime from 'components/Pages/Entity/ContentOverTime.jsx';
import medal from 'images/icons/medal.svg';
import { TopDataContainer, TopDataOverlay, ContentOverTimeContainer } from '../styled';

class PublisherPaidStats extends React.Component {
  render() {
    const {
      topBrandList,
      getTopBrands,
      topKeywordList,
      getTopKeywords,
      contentOverTimeList,
      getContentOverTime,
      setFilters,
      background,
     } = this.props;
    return (
      <Box width="100%" height="330px" mb="36px">
        <TopDataContainer background={background}>
          <TopDataOverlay>
            <TopSixList
              width="50%"
              fetchStore={clear => getTopBrands(clear)}
              store={topBrandList}
              titleIcon={medal}
              title={<Title titleIcon={medal}>Most Used Brands</Title>}
              columns={2}
              showIndex
              showFilters
              setFilters={filters => setFilters(filters, SET_PUBLISHER_TOP_BRANDS_FILTER)}
            >
              <EntityItem type="brand" />
            </TopSixList>
            <TopSixList
              width="50%"
              fetchStore={clear => getTopKeywords(clear)}
              store={topKeywordList}
              titleIcon={medal}
              title={<Title titleIcon={medal}>Most Used Keywords</Title>}
              columns={2}
              showIndex
              showFilters
              setFilters={filters => setFilters(filters, SET_PUBLISHER_TOP_KEYWORDS_FILTER)}
            >
              <KeywordSearchLink />
            </TopSixList>
          </TopDataOverlay>
        </TopDataContainer>
        <ContentOverTimeContainer>
          <ContentOverTime
            store={contentOverTimeList}
            storeFetch={getContentOverTime}
            showFilters
            setFilters={filters => setFilters(filters, SET_PUBLISHER_CONTENT_OVER_TIME_FILTER)}
          />
        </ContentOverTimeContainer>
      </Box>
    );
  }
}

const mapStateToProps = ({
  PublisherProfile: {
    metadata,
    topBrandList,
    topKeywordList,
    contentOverTimeList } }) => ({ metadata, topBrandList, topKeywordList, contentOverTimeList });

const mapDispatchToProps = (dispatch, { entityId }) => ({
  getTopBrands: clear => dispatch(fetchPublishersTopBrands(clear, entityId)),
  getTopKeywords: clear => dispatch(fetchPublishersTopKeywords(clear, entityId)),
  getContentOverTime: clear => dispatch(fetchPublisherContentOverTime(clear, entityId)),
  setFilters: (filters, type) => dispatch({ type, filters }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublisherPaidStats);
